import { Stack, Typography } from "@mui/material";
import React, { useState } from "react";
import { StyledModal } from "../../Modals/StandardModal/StandardModal.styles";
import { StyledButton } from "../../ManageUsersPage/SquadManager.styles";

const Index1Link = (props) => {

	let [ showModal, setShowModal ] = useState(false);
	
	return (
		<>
			<Stack
				direction="column"
				alignContent="center"
				alignItems="center"
				sx= {{
					width: "100%",
					marginTop: "2em",
					padding: "0.5em",
					borderRadius: "1em",
					backgroundColor: "#181818",
					'&:hover': {
						cursor: "pointer"
					}
				}}
				onClick={() => { setShowModal(true); }}
			>
				<Typography
					sx={{
						fontSize: "1.5em",
						fontWeight: "bold",
						fontFamily: "GraphikMedium,sans-serif",
						letterSpacing:"0.175em"
					}}
				>
					LOOKING FOR INDEX 1?
				</Typography>
				<Typography
					sx={{
						fontSize: "0.8em",
						fontWeight: "bold",
						textDecoration: "underline",
						letterSpacing:"0.1em"
					}}
				>
					CLICK HERE TO ACCESS THE OLD PORTAL
				</Typography>
			</Stack>
			<StyledModal
				open={showModal}
				width="80%"
				btnText={'OK'}
				onClick={() => { setShowModal(false); }}
			>
				<Stack
					direction="column"
					alignContent="center"
					alignItems="center"
					sx={{
						borderRadius: "1em",
						padding: "1em"
					}}
				>
					<Typography
						sx={{
							fontSize: "1.5em",
							fontWeight: "bold",
							fontFamily: "GraphikMedium,sans-serif",
							letterSpacing:"0.175em",
							marginTop: "1em"
						}}
					>
						PLEASE NOTE
					</Typography>
					<Typography
						sx={{
							fontSize: "0.8em",
							fontWeight: "bold",
							letterSpacing:"0.1em",
							marginTop: "1em",
							textAlign: "center"
						}}
					>
						CHANGES MADE IN REZZIL INDEX 1 WILL NOT BE REFLECTED IN THE LATEST VERSIONS OF REZZIL INDEX
					</Typography>
					<StyledButton
						variant='text'
						onClick={() => {
							setShowModal(false);
							window.location.href = "https://cms.mhs-services.com/";
						}}
						sx={{ marginTop: "2em", padding: "1em", fontWeight: "bold" }}
					>
						I UNDERSTAND - TAKE ME TO REZZIL INDEX 1
					</StyledButton>
				</Stack>
			</StyledModal>
		</>
	);

}

export default Index1Link;